exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".waitingLoader{\n    width: 7rem;\n    height: 8rem;\n    margin: 0 auto;\n    margin-top: 10rem;\n    border-radius: 100%;\n    border: 10px dotted #0000;\n    border-top-color: #280503;\n    animation: spinner 0.9s linear infinite;\n}\n\n@keyframes spinner {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n\n  .waitModal {\n    display: flex; /* Hidden by default */\n    position: fixed; /* Stay in place */\n    z-index: 999999; /* Sit on top */\n    padding-top: 100px; /* Location of the box */\n    left: 0;\n    top: 0;\n    width: 100%; /* Full width */\n    height: 100%; /* Full height */\n    overflow: auto; /* Enable scroll if needed */\n    background-color: rgb(0,0,0); /* Fallback color */\n    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */\n  }", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/Modules/Loader/waitingloader.css
// module id = 1589
// module chunks = 0